'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import type { ReactNode } from 'react';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

interface ApplicationHeaderContextValue {
  portalElement: HTMLElement | null;
  setPortalElement: (element: HTMLElement | null) => void;
}

const ApplicationHeaderContext = createContext<ApplicationHeaderContextValue | null>(null);

export function ApplicationHeaderProvider({ children }: { children: ReactNode }) {
  const [portalElement, setPortalElementState] = useState<HTMLElement | null>(null);
  const setPortalElement = useCallback((element: HTMLElement | null) => {
    setPortalElementState(element);
  }, []);

  const value = useMemo(
    () => ({
      portalElement,
      setPortalElement,
    }),
    [portalElement, setPortalElement]
  );

  return (
    <ApplicationHeaderContext.Provider value={value}>{children}</ApplicationHeaderContext.Provider>
  );
}

export function useApplicationHeader() {
  const context = useContext(ApplicationHeaderContext);
  if (!context) {
    throw new Error('useApplicationHeader must be used inside ApplicationHeaderProvider');
  }
  return context;
}

export function ApplicationHeaderSlot({ children }: { children: ReactNode }) {
  const { portalElement } = useApplicationHeader();

  if (!portalElement) return null;

  return createPortal(children, portalElement);
}

export function ApplicationHeaderPortalMount() {
  const { setPortalElement } = useApplicationHeader();

  return <div ref={setPortalElement} className="flex min-w-0 items-center" />;
}
